import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import Header from "../../components/ui/Header";
import NewAnalysisCard from "./components/NewAnalysisCard";
import { isAuthed, getIdToken } from "../../lib/cognito";

const Dashboard = () => {
  const [displayName, setDisplayName] = useState("User");
  const navigate = useNavigate();

  useEffect(() => {
    async function loadUser() {
      try {
        const authed = await isAuthed();
        if (!authed) return navigate("/login-screen");

        const token = await getIdToken();
        if (!token) return navigate("/login-screen");

        const jwtPayload = JSON.parse(atob(token.split(".")[1]));

        const name =
          jwtPayload.name ||
          jwtPayload.given_name ||
          jwtPayload.preferred_username ||
          (jwtPayload.email ? jwtPayload.email.split("@")[0] : "User");

        setDisplayName(name);
      } catch {
        navigate("/login-screen");
      }
    }

    loadUser();
  }, [navigate]);

  // ⭐ SCROLL LOCK → titremeyi %100 yok eder
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Dashboard - Graft Counter</title>
      </Helmet>

      {/* ⭐ Overflow-hidden wrapper → scroll jitter tamamen biter */}
      <div className="relative min-h-screen w-full overflow-hidden bg-[url('/assets/images/medical.jpg')] bg-cover bg-center bg-no-repeat bg-fixed">

        {/* dark overlay */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(15,23,42,0.85),rgba(15,23,42,0.97))]" />

        {/* subtle glows */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute -top-20 left-24 w-[400px] h-[400px] bg-cyan-300/10 blur-[160px]" />
          <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-sky-500/10 blur-[200px]" />
        </div>

        {/* CONTENT */}
        <div className="relative z-10 flex flex-col min-h-screen">

          {/* Header */}
          <Header />

          {/* CENTER CONTENT */}
          <div className="flex flex-col items-center px-6 mt-10 h-[calc(100vh-90px)]">

            {/* Welcome panel */}
            <div className="w-full max-w-3xl bg-white/[0.04] backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_20px_50px_rgba(0,0,0,0.4)]">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs text-white/40 font-medium tracking-[0.12em] uppercase mb-1">
                    {new Date().toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" })}
                  </p>
                  <h1 className="text-2xl font-light text-white tracking-tight">
                    Welcome back, <span className="text-blue-300">{displayName}</span>
                  </h1>
                </div>
                <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-green-500/10 border border-green-500/20">
                  <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" />
                  <span className="text-green-300 text-xs font-medium">System Ready</span>
                </div>
              </div>
            </div>

            {/* New analysis card */}
            <div className="flex items-center justify-center w-full max-w-4xl mt-8">
              <NewAnalysisCard />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
